import React, { useState } from "react";
import "../../../styles/Auth/productPopup.css";

const ViewOrderPopup = ({ order, onClose }) => {
  if (!order) return null;

  const {
    orderId,
    customerId,
    shippingAddress,
    items = [],
    paymentMethod,
    paymentStatus,
    transactionId,
    amount,
    discountAmount,
    totalAmount,
    orderStatus,
    createdAt
  } = order;

  return (
    <div className="view-popup-overlay">
      <div className="view-popup-wrapper">
        <div className="view-product-popup-card">

          <h6 className="view-product-popup-title">Order Details</h6>

          {/* ORDER META */}
          <div className="product-detail-row">
            <strong>Order ID:</strong> <span>{orderId}</span>
          </div>

          <div className="product-detail-row">
            <strong>Status:</strong> <span>{orderStatus}</span>
          </div>

          <div className="product-detail-row">
            <strong>Date:</strong>{" "}
            <span>{new Date(createdAt).toLocaleString()}</span>
          </div>

          <hr />

          {/* CUSTOMER */}
          <h6 className="product-section-title">Customer</h6>

          <div className="product-detail-row">
            <strong>Name:</strong>{" "}
            <span>{customerId?.name || "Guest"}</span>
          </div>

          <div className="product-detail-row">
            <strong>Email:</strong>{" "}
            <span>{customerId?.email || "-"}</span>
          </div>

          <hr />

          {/* SHIPPING */}
          <h6 className="product-section-title">Shipping Address</h6>

          <div className="product-detail-row">
            {shippingAddress?.doorNo}, {shippingAddress?.streetName},{" "}
            {shippingAddress?.area}, {shippingAddress?.city},{" "}
            {shippingAddress?.state} - {shippingAddress?.pincode}
          </div>

          <div className="product-detail-row">
            <strong>Receiver:</strong>{" "}
            {shippingAddress?.receiverName} (
            {shippingAddress?.receiverMobileNumber})
          </div>

          <hr />

          {/* ITEMS */}
          <h6 className="product-section-title">Order Items</h6>

          {items.map((item) => (
            <div className="order-item-row" key={item._id}>
              <div>
                <strong>
                  {item.productId?.title ||
                    item.productId?._id ||
                    "Product"}
                </strong>
              </div>
              <div>
                Qty: {item.quantity} × ₹{item.price}
              </div>
              <div>Subtotal: ₹{item.subtotal}</div>
            </div>
          ))}

          <hr />

          {/* PAYMENT */}
          <h6 className="product-section-title">Payment</h6>

          <div className="product-detail-row">
            <strong>Method:</strong> {paymentMethod}
          </div>

          <div className="product-detail-row">
            <strong>Status:</strong>{" "}
            <span
              style={{
                color:
                  paymentStatus === "paid"
                    ? "green"
                    : paymentStatus === "failed"
                    ? "red"
                    : "orange",
                fontWeight: 600
              }}
            >
              {paymentStatus}
            </span>
          </div>

          {transactionId && (
            <div className="product-detail-row">
              <strong>Transaction ID:</strong> {transactionId}
            </div>
          )}

          <hr />

          {/* AMOUNT */}
          <h6 className="product-section-title">Amount Summary</h6>

          <div className="product-detail-row">
            <strong>Amount:</strong> ₹{amount}
          </div>

          <div className="product-detail-row">
            <strong>Discount:</strong> ₹{discountAmount}
          </div>

          <div className="product-detail-row">
            <strong>Total:</strong>{" "}
            <span style={{ fontWeight: 700 }}>₹{totalAmount}</span>
          </div>

          <button className="product-Done-Button" onClick={onClose}>
            Close
          </button>

        </div>
      </div>
    </div>
  );
};

export default ViewOrderPopup;